import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled UI error caught by ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3 p-8 text-center" data-testid="error-boundary-fallback">
          <p className="text-sm font-semibold text-zinc-700">Something went wrong showing this content.</p>
          <button
            type="button"
            className="rounded-sm border border-zinc-300 bg-white px-4 py-2 text-sm hover:bg-zinc-50"
            onClick={() => window.location.reload()}
            data-testid="error-boundary-reload-button"
          >
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
